import { defineComponent as _defineComponent } from 'vue'
import TmButton from '@/ui/tm-button/tm-button.vue'
import { TmButtonTypes } from '@/ui/tm-button/tm-button.types'
import ConfirmationDialog from '@/ui/confirmation-dialog/confirmation-dialog.vue'
import { ref } from 'vue'
import {
    ButtonWithConfirmationDialogTextContent
} from '@/ui/button-with-confirmation-dialog/button-with-confirmation-dialog.types'
import { Icon } from '@/ui/tm-icon/tm-icons.types'

interface Props {
    textContent: ButtonWithConfirmationDialogTextContent
    type: TmButtonTypes
    icon?: Icon
    loading?: boolean
    disabled?: boolean
    attention?: boolean
    small?: boolean
    confirm: () => Promise<void>
    cancel?: () => Promise<void>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'button-with-confirmation-dialog',
  props: {
    textContent: null,
    type: null,
    icon: null,
    loading: { type: Boolean },
    disabled: { type: Boolean },
    attention: { type: Boolean },
    small: { type: Boolean },
    confirm: null,
    cancel: null
  },
  setup(__props: any) {

const props = __props as {
    textContent: ButtonWithConfirmationDialogTextContent
    type: TmButtonTypes
    icon?: Icon
    loading?: boolean
    disabled?: boolean
    attention?: boolean
    small?: boolean
    confirm: () => Promise<void>
    cancel?: () => Promise<void>
}



const open = ref(false)

const handleCancel = async () => {
    open.value = false

    if (props.cancel) {
        await props.cancel()
    }
}

const handleConfirm = async () => {
    open.value = false

    await props.confirm()
}

return { __sfc: true,props, open, handleCancel, handleConfirm, TmButton, ConfirmationDialog }
}

})